
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import _Link from 'next/link'
import { Heading as _Heading } from '@/components/Heading'
import Resources from './_resources.mdx';
import Checklist from './_checklist.mdx';
const Layout = require('@/layouts/RootFileLayout').RootFileLayout;
const meta = {
  "title": "Here is the toolkit to develop your Drugstore Marketplace Platform, and Apps",
  "date": "2021-05-30"
};
const slug = 'drugstore-marketplace-app';
const tableOfContents = [{
  "title": "Drugstore Marketplace",
  "slug": "drugstore-marketplace",
  "children": []
}];

const layoutProps = {
  Layout,
meta,
slug,
tableOfContents
};
const MDXLayout = require('@/layouts/CustomContentsLayout').CustomContentsLayout
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">





    <p>{`Looking to build a Drugstore marketplace and apps? Here is the toolkit to build & launch any marketplace without writing a line of code.`}</p>
    <p><a parentName="p" {...{
        "href": "https://tradly.app/"
      }}>{`Tradly Platform`}</a>{` has an easy-to-use UI to build any marketplace like Drugstore marketplace all the features can be controlled in the SuperAdmin panel (dashboard). It is a complete white label solution…`}</p>
    <p>{`The marketplace can be built on any platform, whether it is Android or iOS. Along with this option, you also get a web app template to get started.`}</p>
    <p>{`Here is an example of how you can configure the catalog, listing fields in your marketplace…`}</p>
    <_Heading level={2} id={"drugstore-marketplace"} nextElement={{
      "type": "jsx"
    }}>Drugstore Marketplace</_Heading>
    <img class="w-92 h-82 object-cover rounded-lg shadow-lg" src={require('../img/tradly/ezgif.com-gif-maker.jpg').default} alt="DrugStore Marketplace" width="700" />
https://dribbble.com/shots/6864315-Hims-Pharmacy-Mobile-Application
    <Checklist mdxType="Checklist" />
    <Resources mdxType="Resources" />



    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
MDXContent.layoutProps = layoutProps
